const nfpetsMinting = {
    context: {},
    selected: [],

    //Sections
    nftGridWrap: document.getElementById("nftSelectGridWrap"),
    nftGrid: document.getElementById("nftGrid"),
    redeemedSection: document.getElementById("redeemed"),
    customizeSection: document.getElementById('customizeSection'),
    customSelect: document.getElementById('customSelect'),
    summarySection: document.getElementById('summary'),
    modal: new NfpModal(),

    spinnerHTML: `<div class="dots m-auto"></div>`,

    // Copy bits
    multiSelectHead: document.getElementById("multiSelectHead"),
    multiSelectCopy: document.getElementById("multiSelectCopy"),
    redeemedImg: document.getElementById("redeemedImg"),
    redeemedHead: document.getElementById("redeemedHead"),
    redeemedCopy: document.getElementById("redeemedCopy"),
    pageCopy: [
        {
            modalCopy: "You're about to redeem a Sparky for:",
            multiSelectHead: "Which NFPs are redeeming a Sparky?",
            multiSelectCopy: "Click/tap to toggle which NFPs will be redeeming a Sparky NFT",
            redeemedImg: `<img src="https://cdn.daz3d.com/file/dazcdn/media/nfpets/sparky.png" class="img-fluid" alt="">`,
            redeemedHead: `Sparky<span class="pluralize" style="display:none">s</span> Redeemed`,
            redeemedCopy: `Congrats! You’ve redeemed the following Sparky<span class="pluralize" style="display:none">s</span>: <span class="nft-ids"></span><br>Share your new best friend<span class="pluralize" style="display:none">s</span> on social media!`
        },
        {
            modalCopy: "You're about to redeem Super Sparky for:",
            multiSelectHead: "Which NFPs are redeeming a Super Sparky?",
            multiSelectCopy: "Click/tap to toggle which NFPs will be redeeming a Super Sparky",
            redeemedImg: `<img src="https://cdn.daz3d.com/file/dazcdn/media/nfpets/super-sparky.jpg" class="img-fluid" alt="">`,
            redeemedHead: `Super Sparky<span class="pluralize" style="display:none">s</span> Redeemed`,
            redeemedCopy: `Congrats! You’ve redeemed the following Super Sparky<span class="pluralize" style="display:none">s</span>: <span class="nft-ids"></span><br>Share your new best friend<span class="pluralize" style="display:none">s</span> on social media!`
        },
        {
            modalCopy: "You're about to redeem Super Sparky for:",
            multiSelectHead: "Which NFPs are redeeming a Super Sparky?",
            multiSelectCopy: "Click/tap to toggle which NFPs will be redeeming a Super Sparky",
            redeemedImg: `<img src="https://cdn.daz3d.com/file/dazcdn/media/nfpets/super-sparky.jpg" class="img-fluid" alt="">`,
            redeemedHead: `Super Sparky<span class="pluralize" style="display:none">s</span> Redeemed`,
            redeemedCopy: `Congrats! You’ve redeemed the following Super Sparky<span class="pluralize" style="display:none">s</span>: <span class="nft-ids"></span><br>Share your new best friend<span class="pluralize" style="display:none">s</span> on social media!`
        }, {
            redeemedImg: `<img src="https://cdn.daz3d.com/file/dazcdn/media/nfpets/super-sparky.jpg" class="img-fluid" alt="">`,
            redeemedHead: `Super Sparky<span class="pluralize" style="display:none">s</span> Redeemed`,
            redeemedCopy: `Congrats! You’ve redeemed the following Super Sparky<span class="pluralize" style="display:none">s</span>: <span class="nft-ids"></span><br>Share your new best friend<span class="pluralize" style="display:none">s</span> on social media!`
        }
    ],

    init: async function () {
        // SET UP CONTEXT INFO
        let ctx = {}

        // CONTEXT TYPE based on a query string from the previous page
        const qs = new URLSearchParams(window.location.search);
        const qsParams = Object.fromEntries(qs.entries());

        switch (qsParams.context) {
            case 'supersparky':
            case '1':
                ctx.type = 1;
                break;
            case 'exchange':
            case '2':
                ctx.type = 2;
                break;
            default:
                ctx.type = 0;
        }
        // CONTEXT NFTS is their owned NFT ids and images
        const tokens = await daz.nfpets.mint.GetNFPs();
        if (tokens.length === 0) {
            this.modal.View('No NFPs Found', 'You currently do not own any NFPs!', [
                {
                    text: 'Buy an NFP on OpenSea',
                    callback: () => {
                        window.open('https://opensea.io/collection/non-fungible-people-daz3d')
                        return false;
                    }
                }
            ], false)
            return;
        }
        ctx.nfts = this.getUserOwnedNfts(tokens);

        if (await this.showCustomizationSection(true)) {
            return
        }

        // CONTEXT PRODUCT is the user readable version of the product name
        if (ctx.type === 1) {   // Redeem Super Sparky
            ctx.product = 'Super Sparky'
            ctx.allowed = await this.getTokensForRedeem(tokens);
        } else if (ctx.type === 2) { // Convert Sparky to Super Sparky
            ctx.product = 'Super Sparky';
            ctx.allowed = await this.getTokensForExchange(tokens);
        } else { // Redeem Sparky
            ctx.type = 0;
            ctx.product = 'Golden Lab'
            ctx.allowed = await this.getTokensForRedeem(tokens);
        }

        this.context = ctx;

        // Add body class based on context
        document.body.classList.add("type-" + ctx.type);

        this.clearModal();

        document.querySelectorAll(".view-opensea").forEach((e) => {
            e.href = "https://opensea.io/" + dazethutil.me();
        });

        if (ctx.allowed.length === 1 && ctx.nfts.length === 1) {
            for (const i in ctx.nfts) {
                if (ctx.nfts[i].id === ctx.allowed[0]) {
                    this.selected.push(this.context.nfts[i]);
                    break;
                }
            }
            // If they only own one NFT then jump straight to the modal for that one
            this.showConfirmationModal();
        } else if (ctx.allowed.length > 0) {
            // If they only own a bunch they need to pick what ones to use
            this.showSelectGrid();
        } else {
            // You umm.... dont have any NFPS
            this.explodeTheSite();
            this.modal.Error('No eligible NFPs found in your wallet!');
        }
    },

    showConfirmationModal: async function () {
        if (this.selected.length === 0) {
            return;
        }
        let idString = this.generateNamesString();
        let prices = await this.getPricing();
        let title = "Mint?";
        let message = `<p style="color: #000000;">You're about to redeem a ${this.context.product} for:</p>
            ${this.selected.length == 1 ? `<img src="${this.selected[0]['img']}">` : ``}
            <p style="color: #000000;">${idString}</p>
            <p style="color: #000000;">${prices.each} + Gas</p>
            `;

        if (prices.discount > 0) {
            message += `<p style="color: #000000;"><span style="font-weight: bold;">Your Discount:</span>&nbsp;${prices.discount} ETH</p>`;
        }

        if (!prices.free) {
            message += `<p style="color: #000000;"><span style="font-weight: bold;">Your Total:</span>&nbsp;${prices.total} + Gas</p>`;
        }

        this.modal.viewModal({
            titleStr: title,
            msgStr: message,
            dismissOnBlur: true,
            btnObjArr: [
                {
                    text: 'Mint Now',
                    callback: async () => {
                        nfpetsMinting.purchaseSelected().then(() => {

                        }, err => {
                            if (err === 'canceled') {
                                this.nftGridWrap.style.display = '';
                                this.showSelectGrid();
                                return false;
                            }
                            this.modal.Critical(
                                'Transaction Error',
                                'There was an error with your transaction or you canceled it. Please check your wallet for more information.',
                                [
                                    {
                                        text: 'Close',
                                        callback: () => {
                                            this.nftGridWrap.style.display = '';
                                            this.showSelectGrid();
                                        }
                                    },
                                ]);
                        });
                        return false;
                    }
                },
                {
                    'text': 'Cancel'
                }
            ],
        })
    },

    showSelectGrid: function () {
        this.multiSelectHead.innerHTML = this.pageCopy[this.context.type].multiSelectHead;
        this.multiSelectCopy.innerHTML = this.pageCopy[this.context.type].multiSelectCopy;
        let allowedHTML = '';
        let disallowedHTML = '';
        this.context.nfts.forEach(element => {
            const isAllowed = this.context.allowed.indexOf(element.id) !== -1;
            const html = `<div class="nfp-item animate faded-out col ${isAllowed ? '' : ' disabled'}">
                <input type="checkbox" class="nfp-checkbox" value="${element.id}" id="nft${element.id}" name="nfp[]" autocomplete="off" ${isAllowed ? '' : ' disabled'}>
                <label for="nft${element.id}">
                    <img class="nfp-thumb img-fluid" src="${element.img}">
                    <p class="nfp-title text-center pb-3 pt-1">NFP#${element.id}</p>
                </label>
            </div>`;
            if (isAllowed) {
                allowedHTML += html;
            } else {
                disallowedHTML += html;
            }
        });

        this.nftGrid.innerHTML = allowedHTML + disallowedHTML;
        this.nftGridWrap.style.display = 'block';
        setTimeout(function () {
            nfpetsMinting.nftGridWrap.classList.remove('faded-out');
        }, 20);


        // Now animate them in
        let nfts = this.nftGrid.querySelectorAll('.animate')
        nfts.forEach(function (el, i) {
            setTimeout(function () {
                el.classList.remove('faded-out');
            }, i * 150);
        });

    },

    showRedeemedSection: async function () {
        this.redeemedImg.innerHTML = this.pageCopy[this.context.type].redeemedImg;
        this.redeemedHead.innerHTML = this.pageCopy[this.context.type].redeemedHead;
        this.redeemedCopy.innerHTML = this.pageCopy[this.context.type].redeemedCopy;
        let idString = this.generateNamesString();

        if (this.selected.length > 1) {
            this.redeemedHead.querySelectorAll('.pluralize').forEach(e => {
                e.style.display = 'inline';
            })
            this.redeemedCopy.querySelectorAll('.pluralize').forEach(e => {
                e.style.display = 'inline';
            })
        }

        this.redeemedCopy.querySelectorAll('.nft-ids').forEach(element => {
            element.innerText = idString;
        });

        this.redeemedSection.style.display = 'block';
        this.nftGridWrap.style.display = 'none';

        setTimeout(() => {
            nfpetsMinting.redeemedSection.classList.remove('faded-out');
            this.clearModal();
        }, 20);
    },

    showCustomizationSection: async function (recovery = false) {
        this.modal.viewModal({msgStr: this.spinnerHTML, dismissOnBlur: false});

        let sig = await daz.nfpets.mint.Sign(true);
        if (!sig) {
            while (true) {
                this.modal.Critical('Signature Required', 'You must sign this message using your wallet to continue with the customization process.')
                sig = await daz.nfpets.mint.Sign(true);
                if (!sig) {
                    await this.modal.ErrorAsync('Signature Required', 'You must sign this message using your wallet to continue with the customization process.');
                    continue;
                }
                break;
            }
            this.modal.viewModal({msgStr: this.spinnerHTML, dismissOnBlur: false});
        }

        const litters = await this.getLitters();
        if (recovery && litters.length === 0) {
            return false;
        }

        const tokens = [];
        for (const l in litters) {
            tokens.push(litters[l].NFP.toString());
        }
        if (recovery) {
            this.selected = this.getUserOwnedNfts(tokens);
            this.context.type = 3;
            this.context.product = 'Super Sparky';
        } else {
            let allInList = true;
            for (const i in this.selected) {
                allInList = allInList && tokens.indexOf(this.selected[i].id.toString()) !== -1;
            }
            if (!allInList) {
                setTimeout(() => {
                    this.showCustomizationSection(false);
                }, 5000);
                return true;
            }
        }
        let customizeHTML = '';

        this.startCountdown(litters[0].Time);

        this.selected.forEach(element => {
            for (const i in litters) {
                if (litters[i].NFP.toString() !== element.id.toString()) {
                    continue;
                }
                customizeHTML += `<div class="row gx-1 gy-1 justify-content-center nft-custom-container" data-selected="false" data-flipped="false" data-name="nft${element.id}-options"">
            <div class="m-3 d-flex justify-content-center">
            <div class="row gx-1 gy-1 py-2 px-4 text-center" style="outline: 1px solid rgba(255,255,255,0.6);padding: 2px;background: rgb(230,18,238);background: linear-gradient(90deg, rgba(230,18,238,0.47942927170868344) 0%, rgba(230,18,238,0) 44%, rgba(230,18,238,0) 53%, rgba(230,18,238,0.44861694677871145) 100%);/*border-color: rgba(255,255,255,0.99);*/">
            <div class="col-12 col-xs-4 col-sm-2 align-self-center pt-1"><img class="mt-3 img-fluid" src="${element.img}" style="border: 1px solid #fff;">
            <p>NFP #${element.id}</p>
            </div>`

                for (let l = 0; l < litters[i].Litter.length; l++) {
                    let filename = litters[i].Litter[l];
                    const img = `https://nftcdn.daz3d.com/nfp/pets/mint/${filename}.png`;
                    const full = `https://nftcdn.daz3d.com/nfp/pets/mint/${filename}_Full.png`;

                    customizeHTML += `<div class="col col-xs-4 col-sm-2 align-self-center animate faded-out pet-item ">
                    <input type="radio" class="pet-radio" name="index[${element.id}]" id="nft${element.id}-option${l}" disabled data-nft="${element.id}" value="${l}" >

                    <label for="nft${element.id}-option${l}">
                    <div class="flipper-wrap flipped">
                    <div class="flipper-inner">
                    <div class="flip-front">
                        <img class="pet-thumb img-fluid" alt="Pet ${l + 1} for NFP #${element.id}" src="${img}">
                    </div>
                    <div class="flip-back">
                        <img src="https://cdn.daz3d.com/file/dazcdn/media/nfpets/pawprint.png" class="img-fluid img-paw" alt="">
                        <img class="img-fluid img-full" alt="Pet ${l + 1} Full Body for NFP #${element.id}" src="${full}" style="display:none">
                    </div>
                    </div>
                    </div>
                    </label>
                    </div>`
                }

                customizeHTML += `</div></div></div>`;
            }

        });

        this.customSelect.innerHTML = customizeHTML;
        this.customSelect.querySelectorAll('.nft-custom-container').forEach((elem) => {
            elem.addEventListener('click', () => {
                if (this.allActiveRowsHaveSelection()) {
                    this.enableNextRowOptions();
                }
            })
        });
        this.customizeSection.style.display = 'block';
        this.nftGridWrap.style.display = 'none';

        setTimeout(() => {
            this.customizeSection.classList.remove('faded-out');
        }, 20);

        // Now animate them in
        let options = this.customSelect.querySelectorAll('.animate')
        options.forEach(function (el, i) {
            setTimeout(function () {
                el.classList.remove('faded-out');
            }, i * 150);
        });
        this.enableNextRowOptions();
        this.clearModal();
        return true;
    },

    enableNextRowOptions: function () {
        const cc = document.querySelector('.commit-customize')
        let rows = document.querySelectorAll('.nft-custom-container[data-flipped="false"]');
        // do we still have a unflipped row?
        const inputsToEnable = [];
        const petItemsToFlip = [];
        if (rows.length >= 1) {
            let inputs = rows[0].querySelectorAll('input');

            inputs.forEach(function (input, i) {
                setTimeout(function () {
                    let label = input.nextElementSibling;
                    let flipper = label.querySelectorAll('.flipper-wrap')
                    flipper[0].classList.remove('flipped');

                    setTimeout(() => {
                        label.querySelector('.img-paw').style.display = "none";
                        label.querySelector('.img-full').style.display = "";
                        inputsToEnable.push(input);
                        petItemsToFlip.push(label.closest('.pet-item'));

                        if (i === 4) {
                            inputsToEnable.forEach((elem) => {
                                elem.disabled = false;
                            });
                            petItemsToFlip.forEach((elem) => {
                                elem.classList.add('flippable');
                            });
                        }
                    }, 650);
                }, i * 500);
            })

            rows[0].setAttribute('data-flipped', "true")
            cc.disabled = true;
            cc.classList.add('disabled');
        } else {
            cc.disabled = false;
            cc.classList.remove('disabled');
        }
    },

    allActiveRowsHaveSelection: function () {
        let allSelected = true;
        let rows = document.querySelectorAll('.nft-custom-container[data-flipped="true"]');
        rows.forEach(function (row, i) {
            const checkSelected = row.querySelectorAll('input:checked');
            if (checkSelected.length == 0) {
                allSelected = false
            }
        });
        return allSelected;
    },

    showAdditionalConfirmation: async function () {
        return new Promise((resolve, reject) => {
            this.modal.viewModal({
                titleStr: "Are you sure?",
                msgStr: `<p>This action will burn your Sparky NFT and is irreversible</p>`,
                btnObjArr: [
                    {
                        text: 'Proceed',
                        callback: () => {
                            resolve(true);
                        }
                    },
                    {
                        text: 'Cancel',
                        callback: () => {
                            reject('canceled');
                        }
                    },
                ],
                dismissOnBlur: false,
            })
        });
    },


    showFinalWarning: async function () {
        return new Promise((resolve, reject) => {
            this.modal.viewModal({
                titleStr: "Finalize?",
                msgStr: `<p>Once you submit you will not be able to change your selections.</p>`,
                btnObjArr: [
                    {
                        text: 'Proceed',
                        callback: () => {
                            resolve(true);
                        }
                    },
                    {
                        text: 'Cancel',
                        callback: () => {
                            reject('canceled');
                        }
                    },
                ],
                dismissOnBlur: false,
            })
        });
    },

    showSummarySection: async function (pets) {
        const imgs = document.getElementById('summaryImgs');
        imgs.innerHTML = '';
        const idString = this.getSelectedIds().join(', ');
        pets.forEach((el) => {
            const s = document.createElement("div");
            s.classList.add('flippable', 'summary-thumb');
            s.appendChild(el);
            imgs.appendChild(s);
        })

        document.querySelector('.super-sparkys-summary-string').innerHTML = idString;

        this.summarySection.style.display = 'block';
        this.customizeSection.style.display = 'none';

        if (this.selected.length > 1) {
            document.querySelectorAll('.pluralize').forEach(e => {
                e.style.display = 'inline';
            })
        }

        setTimeout(() => nfpetsMinting.summarySection.classList.remove('faded-out'), 20);

    },

    applyCustomization: async function () {
        const indexes = {};
        let count = 0;

        if (!await nfpetsMinting.showFinalWarning()) {
            return;
        }

        this.modal.viewModal({msgStr: this.spinnerHTML, dismissOnBlur: false});

        const sig = await daz.nfpets.mint.Sign(false);
        if (!sig) {
            throw 'no signature found';
        }

        const selectedPets = [];
        document.querySelectorAll('.pet-radio').forEach(elem => {
            if (!elem.checked) {
                return;
            }
            const id = elem.getAttribute('data-nft');
            const index = elem.value;
            indexes[id] = index;
            count++;
            const qs = elem.closest('.pet-item').querySelector('.flipper-wrap');
            selectedPets.push(qs);
        })

        if (this.selected.length !== count) {
            alert('wrong number selected');
            throw 'invalid number of options selected';
        }

        const now = Math.floor(Date.now() / 1000);
        const data = new FormData();
        data.append('who', dazethutil.me());
        data.append('sig', sig.Signature);
        data.append('sigHash', sig.SigHash);
        data.append('nonce', sig.Nonce);
        data.append('tokens', sig.Tokens);
        data.append('now', now.toString(10));

        const idx = [];
        const ids = [];
        for (const id in indexes) {
            idx.push(parseInt(indexes[id], 10))
            ids.push(parseInt(id, 10));
            data.append('index[]', indexes[id]);
            data.append('nfp[]', id);
        }
        data.append('hash', dazethutil.hashAll([sig.Signature, sig.Nonce.toString(), dazethutil.me(), now, sig.Tokens, sig.SigHash, dazethutil.hashAll(idx), dazethutil.hashAll(ids)]))

        return fetch("/nft-api/nfpets/adopt", {
            method: 'POST',
            body: data,
        }).then(async response => {
            if (!response.ok) {
                throw await response.text();
            }
            return response.json();
        }).then(async (json) => {
            this.explodeTheSite();
            await this.showSummarySection(selectedPets);
        }).catch(async txt => {
            let err = "";
            try {
                err = JSON.parse(txt);
            } catch (e) {
                err = {error: txt};
            }
            throw err.error;
        });
    },

    chooseForMe: async function () {
        document.querySelectorAll('.nft-custom-container').forEach(elem => {
            const radios = elem.querySelectorAll("input[type='radio']");
            radios[Math.floor(Math.random() * 5)].checked = true;
            elem.querySelectorAll('.flipper-wrap').forEach((fw) => {
                fw.classList.add('flipped-fast');
                fw.classList.remove('flipped');
                fw.closest('.pet-item').classList.add('flippable');
                setTimeout(() => {
                    fw.classList.remove('flipped-fast');
                    fw.querySelector('.img-paw').style.display = "none";
                    fw.querySelector('.img-full').style.display = "";
                }, 100)
            })
            radios.forEach((radio) => {
                radio.disabled = false;
            })

            elem.setAttribute('data-flipped', 'true');
        })
        return this.applyCustomization();
    },

    purchaseSelected: async function () {

        this.nftGridWrap.style.display = 'none';

        if (this.context.type === 2 && !await this.showAdditionalConfirmation()) {
            return;
        }

        if (this.selected.length === 0) {
            return;
        }
        if (this.context.type === 0) {
            this.modal.viewModal({msgStr: this.spinnerHTML, dismissOnBlur: false});
        } else {
            this.modal.viewModal({
                msgStr: '<p>Please wait a moment in order to select your new pet!</p>' + this.spinnerHTML,
                dismissOnBlur: false
            });
        }

        let p = null;
        if (this.context.type === 1) {
            p = daz.nfpets.superSparky.MintFromNFP(this.getSelectedIds(), (trx) => this.onTransactionHash(trx));
        } else if (this.context.type === 2) {
            p = daz.nfpets.superSparky.MintFromSparky(this.getSelectedIds(), (trx) => this.onTransactionHash(trx));
        } else {
            p = daz.nfpets.sparky.Mint(this.getSelectedIds(), (trx) => this.onTransactionHash(trx));
        }

        return p.then(async (trx) => {
            this.modal.viewModal({msgStr: this.spinnerHTML, dismissOnBlur: false});
            if (this.context.type >= 1) {
                // for super we need to now pick the customization
                return this.showCustomizationSection();
            } else {
                // for non super we are done
                return this.showRedeemedSection(trx);
            }
        }, err => {
            console.error(err);
            throw err;
        });
    },

    onTransactionHash: function (hash) {
        let hasp = hash.substr(0, 10) + '...' + hash.substr(hash.length - 10, 10);
        const title = "Transaction Processing";
        const message = `The Ethereum network is processing your transaction. Your transaction hash is: <span title="${hash}">${hasp}</a>`;
        this.modal.viewModal({
            titleStr: title,
            msgStr: message,
            btnObjArr: [
                {
                    text: 'View on Etherscan',
                    callback: () => {
                        window.open(`https://etherscan.io/tx/${hash}`)
                        return false;
                    }
                },
            ],
            dismissOnBlur: false
        })
    },

    getTokensForRedeem: async function () {
        return daz.nfpets.mint.GetNfpsForMint();
    },

    getTokensForExchange: async function (tokens) {
        return daz.nfpets.sparky.NfpsWith(tokens)
            .then(isWith => daz.nfpets.superSparky.NfpsAllowed(isWith));
    },

    getPricing: async function () {
        if (this.context.type === 0) {
            return {
                each: 'Free',
                total: 0,
                discount: 0,
                free: true
            };
        } else {
            const ids = this.getSelectedIds();
            let cost = await daz.nfpets.superSparky.GetPrice(ids);
            let rawCost = await daz.nfpets.superSparky.GetPriceNoDiscount(ids.length);
            let discount = dazeth.web3.utils.fromWei((rawCost - cost).toString(10), 'ether');
            let pricePer = dazeth.web3.utils.fromWei((rawCost / ids.length).toString(10), 'ether') + ' ETH/ea';
            let totalPrice = dazeth.web3.utils.fromWei(cost.toString(), 'ether') + ' ETH';
            if (cost.toString() === '0') {
                return {
                    each: pricePer,
                    total: 'Free',
                    discount: discount,
                    free: false
                };

            }
            return {
                each: pricePer,
                total: totalPrice,
                discount,
                free: cost.toString() <= 0
            };
        }
    },

    getSelectedIds: function () {
        const ids = [];
        for (const i in this.selected) {
            ids.push(this.selected[i].id);
        }
        return ids;
    },

    getUserOwnedNfts: function (tokens) {
        const result = []
        for (const i in tokens) {
            result.push({
                id: tokens[i],
                img: "https://nftcdn.daz3d.com/nfp/gen1/t/" + tokens[i]
            })
        }
        return result;
    },

    getLitters: async function () {
        const sig = await daz.nfpets.mint.Sign(false);
        if (!sig) {
            return [];
        }

        const now = Math.floor(Date.now() / 1000);
        const hash = dazethutil.hashAll([sig.Signature, sig.Nonce.toString(), dazethutil.me(), now, sig.Tokens, sig.SigHash]);
        const data = {
            who: dazethutil.me(),
            sig: sig.Signature,
            sigHash: sig.SigHash,
            nonce: sig.Nonce,
            tokens: sig.Tokens,
            hash: hash,
            now: now.toString(10),
        }

        return fetch("/nft-api/nfpets/litters", {
            method: 'POST',
            body: (new URLSearchParams(data)).toString(),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        }).then(async response => {
            if (!response.ok) {
                throw await response.text();
            }
            return response.json();
        }).catch(async txt => {
            let err = "";
            try {
                err = JSON.parse(txt);
            } catch (e) {
                err = {error: txt};
            }
            throw err.error;
        });
    },

    startCountdown: function (forSeconds) {
        if (this.context.interval) {
            clearInterval(this.context.interval);
            this.context.interval = null;
        }
        this.context.timer = forSeconds;
        const endDate = new Date();
        endDate.setSeconds(endDate.getSeconds() + forSeconds);

        const ifunc = () => {
            const diff = Math.ceil((endDate.getTime() - (new Date()).getTime()) / 1000);
            if (diff <= 0) {
                clearInterval(this.context.interval);
                this.context.interval = null;
                return;
            }
            let min = Math.floor(diff / 60).toFixed(0);
            let sec = (diff - (min * 60)).toFixed(0);
            countdown.innerText = `${min}m ${sec}s`;
        };
        ifunc();
        this.context.interval = setInterval(ifunc, 1000);
    },

    generateNamesString: function () {
        let idString = '';
        this.selected.forEach(element => {
            idString += 'NFP #' + element.id + ', '
        });
        return idString.substring(0, idString.length - 2);
    },

    // Small utils
    clearModal: function () {
        this.modal.Close();
    },
    explodeTheSite: function () {
        this.nftGridWrap.classList.add('faded-out');
        this.nftGridWrap.style.display = 'none';
        this.redeemedSection.classList.add('faded-out');
        this.redeemedSection.style.display = 'none';
        this.customizeSection.classList.add('faded-out');
        this.customizeSection.style.display = 'none';
        this.modal.Close();
    },
}

//Event Handlers

document.getElementById('choose-for-me-button').addEventListener('click', async e => {
    return nfpetsMinting.chooseForMe();
});

document.querySelector('.multi-submit').addEventListener('click', e => {
    let checkboxes = document.querySelectorAll('.nfp-checkbox');
    let checkboxesChecked = [];
    for (let i = 0; i < checkboxes.length; i++) {
        if (checkboxes[i].checked) {
            let idx = nfpetsMinting.context.nfts.findIndex(x => x.id == checkboxes[i].value);
            checkboxesChecked.push(nfpetsMinting.context.nfts[idx]);
        }
    }
    nfpetsMinting.selected = checkboxesChecked;
    if (nfpetsMinting.selected.length >= 1) {
        nfpetsMinting.showConfirmationModal();
    }
});

document.querySelector('.commit-customize').addEventListener('click', async e => {
    return nfpetsMinting.applyCustomization().then().catch(err => {
        if (err === 'canceled') {
            nfpetsMinting.customizeSection.style.display = 'block';
        } else {
            console.error(err);

            return nfpetsMinting.showCustomizationSection(true);
        }
    });
});
